import {
  CARD_GAP_DESKTOP_VW_FACTOR,
  CARD_GAP_MOBILE_PX,
  TEAM_CARD_DESKTOP_HEIGHT,
  TEAM_CARD_DESKTOP_WIDTH,
  TEAM_CARD_MOBILE_HEIGHT,
  TEAM_CARD_MOBILE_WIDTH,
} from "./constants";

interface UseCarouselGeometryParams {
  isMobile: boolean;
  vw: number;
}

interface CarouselGeometry {
  cardWidth: number;
  cardHeight: number;
  cardGap: number;
  pitch: number;
}

enum CarouselGeometryMode {
  Mobile = "mobile",
  Desktop = "desktop",
}

interface CarouselGeometryRule {
  cardWidth: number;
  cardHeight: number;
  getCardGap: (params: UseCarouselGeometryParams) => number;
}

const CAROUSEL_GEOMETRY_BY_MODE: Record<
  CarouselGeometryMode,
  CarouselGeometryRule
> = {
  [CarouselGeometryMode.Mobile]: {
    cardWidth: TEAM_CARD_MOBILE_WIDTH,
    cardHeight: TEAM_CARD_MOBILE_HEIGHT,
    getCardGap: () => CARD_GAP_MOBILE_PX,
  },
  [CarouselGeometryMode.Desktop]: {
    cardWidth: TEAM_CARD_DESKTOP_WIDTH,
    cardHeight: TEAM_CARD_DESKTOP_HEIGHT,
    getCardGap: ({ vw }) => vw * CARD_GAP_DESKTOP_VW_FACTOR,
  },
};

export function useCarouselGeometry(
  params: UseCarouselGeometryParams,
): CarouselGeometry {
  const mode = params.isMobile
    ? CarouselGeometryMode.Mobile
    : CarouselGeometryMode.Desktop;
  const rule = CAROUSEL_GEOMETRY_BY_MODE[mode];
  const cardGap = rule.getCardGap(params);

  return {
    cardWidth: rule.cardWidth,
    cardHeight: rule.cardHeight,
    cardGap,
    pitch: rule.cardWidth + cardGap,
  };
}
